import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/pro-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "components/bookingEngine/orderSummaryLineItem/OrderSummaryLineItem.scss";
import { Badge } from "components/badge/Badge";
import classNames from "classnames";

interface IProps {
  lineItem?: string;
  itemValue?: any;
  lineItemVariant?: string;
  lineItemQuantity?: number;
  itemSubtitle?: string;
  prepaid?: boolean;
  promotional?: boolean;
  promotionLabel?: string | null;
  className?: string;
}

function OrderSummaryLineItem(props: IProps) {
  const { t } = useTranslation();
  const itemName = props.lineItem;
  const itemValue = props.itemValue;
  const itemVariantName = props?.lineItemVariant;
  const itemQuantity = props?.lineItemQuantity;

  return (
    <div>
      <ul className="leaders">
        <li>
          <span className={classNames("line-item", props.className)}>
            {itemQuantity && (
              <span className="item-quantity">
                {itemQuantity}
                {"  "}
              </span>
            )}
            <span
              className={classNames("items-title-container", {
                "items-title-container--promotion": props.promotional,
              })}
            >
              <span className={classNames("item-title", { "item-title--promotion": props.promotional })}>
                {props.promotional ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`order-summary-promotion-${String(itemName)}-${String(itemVariantName ?? "")}`}>
                        {props.promotionLabel || t("Promotion")}
                      </Tooltip>
                    }
                  >
                    <span className="item-promotion-icon-wrap">
                      <FontAwesomeIcon className="item-promotion-icon" icon={faTag} />
                    </span>
                  </OverlayTrigger>
                ) : null}
                {itemName}
              </span>
              {itemVariantName && itemVariantName !== itemName && (
                <span className="item-variant-title">{itemVariantName}</span>
              )}
            </span>

            {props.itemSubtitle && <span className="item-subtitle">{props.itemSubtitle}</span>}
            <div className="item-dots"></div>
            <span className={classNames("item-value", props.className)}>{itemValue}</span>
          </span>
          {props.prepaid ? (
            <Badge type="gray" size="small">
              {t("Prepaid")}
            </Badge>
          ) : null}
        </li>
      </ul>
    </div>
  );
}

export default OrderSummaryLineItem;
